import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@features/auth/store/authStore';

/**
 * Wraps public routes (login, register, etc.) so that
 * authenticated users are redirected to /entities instead.
 */
const PublicRoute: React.FC = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated());

  if (isAuthenticated) {
    return <Navigate to="/entities" replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
